export const FirebaseConfig = {
	"projectId": "lift-luxury-drive",
	"appId": "1:83127526313:web:68710e642044ce97201ab8",
	"databaseURL": "https://lift-luxury-drive-default-rtdb.firebaseio.com",
	"storageBucket": "lift-luxury-drive.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyC8036g2nHkXp-JMBe7Ff_XgBvvCB-STyk",
	"authDomain": "lift-luxury-drive.firebaseapp.com",
	"messagingSenderId": "83127526313",
	"measurementId": "G-JBPSL9YM9Q"
};